import { IoIosArrowForward } from 'react-icons/io';

import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseStarOutlined } from 'assets/images/star-outlined.svg';

type ContainerProps = {
  outlineBg?: boolean;
  $disabled?: boolean;
};

type NameProps = {
  $disabled?: boolean;
};

export const Container = styled.li<ContainerProps>`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  padding: 24px 16px;
  background-color: ${({ $disabled, theme }) => ($disabled ? '#e6e6e6' : theme.groupedList.item.backgroundContainer)};
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.groupedList.item.division};
  }
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const SubItem = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.groupedList.item.textColor};
`;

export const Arrow = styled(IoIosArrowForward)`
  font-size: 20px;
  color: ${ColorPalette.HEX.PineTree} !important;
`;

export const TrashCan = styled.img``;

export const Detail = styled.h6`
  color: ${ColorPalette.HEX.Manatee};
  font-size: 12px;
  line-height: 18px;
`;

export const Name = styled.h5<NameProps>`
  color: ${({ $disabled }) => ($disabled ? ColorPalette.HEX.DimGray : ColorPalette.HEX.PineTree)};
`;

export const BadgeContainer = styled.div`
  display: flex;
  margin-top: 8px;
`;

export const Badge = styled.span<ContainerProps>`
  max-width: 98px;
  height: 24px;
  padding: 0 18px;
  font-size: 10px;
  text-align: center;
  border-radius: 16px;
  color: ${({ theme }) => theme.groupedList.item.textColor};
  background-color: ${({ theme, outlineBg }) =>
    outlineBg ? theme.groupedList.item.backgroundContainer : theme.groupedList.item.background};
  border: 1px solid ${({ theme }) => theme.groupedList.item.background};
  line-height: 2.6;
  ${_ellipsis()};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const NameContainer = styled.div``;

export const ImageContainer = styled.div`
  margin-right: 5px;
`;

export const AllianceImageContainer = styled.div`
  margin: 0 16px;
  width: 32px;

  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e6e6e6;
  border-radius: 8px;
`;

export const AllianceImageContent = styled.div`
  width: 75%;
  height: 75%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 100%;
    width: 100%;
  }
`;

export const EntityTypeImageContainer = styled.div`
  align-self: flex-start;
  margin-top: 2px;
  margin-right: 4px;
  width: 18px;
`;

export const Specific: any = styled.div`
  display: flex;
`;

Specific.Title = styled.span`
  font-size: 16px;
  color: ${ColorPalette.HEX.PineTree};
`;

Specific.Item = styled.div`
  display: flex;
  font-size: 10px;
  color: ${ColorPalette.HEX.Manatee};
  line-height: 1.67;
  letter-spacing: -0.17px;
  margin-right: 8px;
`;

Specific.ItemIcon = styled.img`
  margin-right: 5px;
`;

export const StarOutlined = styled(BaseStarOutlined)`
  color: ${ColorPalette.HEX.DimGray};
  margin: 0 0 -5px 5px;
`;
